export enum MinisiteEditState {
    editHeader = "EDIT_HEADER",
    editDescription = "EDIT_DESC",
}
